
class Client {

    maxRetries = 3
    baseDelayMs = 1000

    get = async (url,headers = {}) => {
        let req = async () => {
            return await fetch (url,{
                method: 'GET',
                headers: {
                    ...headers
                },
                credentials: 'include'
            })
        }
        return await this.request(req,0)
    }

    post = async (url,headers = {},payload) => {
        let req = async () => {
            return await fetch (url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...headers
                },
                credentials: 'include',
                body: JSON.stringify(payload)
            })
        }
        return await this.request(req,0)
    }

    patch = async (url, headers = {}, payload) => {
        let req = async () => {
            return await fetch(url, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    ...headers
                },
                credentials: 'include',
                body: JSON.stringify(payload)
            })
        }
        return await this.request(req, 0)
    }

    postStream = async (url, payload, headers = {}) => {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
            credentials: 'include',
            body: JSON.stringify(payload),
        })

        if (!res.ok) {
            const errorText = await res.text()
            throw new Error(errorText || `Request failed with status ${res.status}`)
        }

        return res
    }

    postForm = async (url, formData, headers = {}) => {
        let req = async () => {
            return await fetch(url, {
                method: 'POST',
                headers: {
                    ...headers
                },
                credentials: 'include',
                body: formData
            })
        }
        return await this.request(req, 0)
    }

    request = async (req, attempt) => {
        const res = await req()
        if (res.ok || attempt === this.maxRetries) {
            return res
        }
        await new Promise((resolve) => setTimeout(resolve, this.backoff(attempt)))
        return await this.request(req, attempt + 1)
    }

    backoff = (attempt) => {
        return this.baseDelayMs * 2 ** attempt
    }
} 

let client = new Client()

export default client